export const METACAM = "metacam";
export const SEMINTRA = "semintra";
export const HEARTGARD = "heartgard";
export const NEXGARD_SPECTRA = "nexgard-spectra";
export const NEXGARD_COMBO = "nexgard-combo";
export const NEXGARD = "nexgard";
export const SENVELGO = "senvelgo";
export const FRONTLINE_PLUS = "frontline-plus";
export const PUREVAX = "purevax";
export const RECOMBITEK = "recombitek";
